
/**
 * Module dependencies.
 */

import { fetchPage } from 'src/api/app/pages/fetch-page';
import { getApiPageSlugByLocale } from 'src/core/utils/routes';
import Legal, { PageProps } from 'src/components/legal';
import React, { ReactElement } from 'react';

/**
 * `Props` type.
 */

type Props = {
  data: PageProps,
  slug: string
};

/**
 * `TermsAndConditions` page.
 */

const TermsAndConditions = (props: Props): ReactElement => (
  <Legal
    {...props}
    routeName={'termsConditions'}
  />
);

/**
 * Export `getServerSideProps`.
 */

export async function getServerSideProps({ locale, query }) {
  const slug = getApiPageSlugByLocale('termsConditions', locale);
  const pageData = await fetchPage({
    hasPreview: query?.preview,
    locale,
    slug
  });

  if (!pageData) {
    return {
      notFound: true
    };
  }

  return {
    props: {
      data: pageData,
      slug
    }
  };
}

/**
 * Export `TermsAndConditions` page.
 */

export default TermsAndConditions;
